export const productVariants = {
  productVariants: {
    style: 'Style',
    selectedStyle: 'Selected style',
    size: 'Size',
    color: 'Color',
    sizeGuideLabel: 'Style guide',
  },
};
